function triggerContentInView() {
  function init() {
    let observer = new IntersectionObserver((entries) => {
      if (entries[0].boundingClientRect.y < 0) {
        document.body.classList.add("content-visible");
      } else {
        document.body.classList.remove("content-visible");
      }
    });
    observer.observe(document.querySelector(".observed-content-start"));
  }

  const isPresent = document.getElementsByClassName("observed-content-start");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerContentInView };

function triggerIntroOutOfView() {
  function init() {
    const content = document.querySelector(".observer-intro");

    let marginValues = "";

    if (document.body.classList.contains("page-template-template-plans")) {
      marginValues = "-200px 0px 0px 0px";
    } else {
      marginValues = "0px 0px 0px 0px";
    }

    const config = {
      rootMargin: marginValues,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio === 0) {
          document.body.classList.add("menu-dark");
        } else {
          document.body.classList.remove("menu-dark");
        }
      });
    }, config);

    observer.observe(content);
  }

  const isPresent = document.getElementsByClassName("observer-intro");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerIntroOutOfView };

function triggerVideo() {
  function init() {
    const video = document.querySelector(".video-module-wrapper");

    const config = {
      // rootMargin: "0px 0px 30% 0px",
      threshold: ["0.55", "1"],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const videoSrc = document.querySelector(".video-module-video");

        if (entry.isIntersecting) {
          if (window.innerWidth > 1024) {
            document.body.classList.add("video-fullscreen");
          }

          window.addEventListener("resize", () => {
            if (window.innerWidth > 1024) {
              document.body.classList.add("video-fullscreen");
            }
          });

          videoSrc.play();
        } else {
          if (window.innerWidth > 1024) {
            document.body.classList.remove("video-fullscreen");
          }

          window.addEventListener("resize", () => {
            if (window.innerWidth > 1024) {
              document.body.classList.remove("video-fullscreen");
            }
          });
          videoSrc.pause();
        }
      });
    }, config);

    observer.observe(video);
  }

  const isPresent = document.getElementsByClassName("video-module-wrapper");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerVideo };

function triggerSlidingContentSettings() {
  function init() {
    const blocks = document.querySelectorAll(".module-sliding-content");

    const config = {
      rootMargin: "0px 0px 200px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          document.body.classList.add("module-sliding-content-inview");
        } else {
          document.body.classList.remove("module-sliding-content-inview");
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  const isPresent = document.getElementsByClassName("module-sliding-content");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerSlidingContentSettings };

function triggerSlidingSliderControls() {
  function init() {
    const blocks = document.querySelectorAll(".module-sliding-content");

    const config = {
      rootMargin: "-100% 0px 0px 0px",
      // threshold: [0, 0.9],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show-controls");
        } else {
          entry.target.classList.remove("show-controls");
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  const isPresent = document.getElementsByClassName("module-sliding-content");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerSlidingSliderControls };

function narrowSlidingSliderControls() {
  function init() {
    const blocks = document.querySelectorAll(".sliding-slider-content");
    const content = document.querySelector(".module-sliding-content");

    const config = {
      rootMargin: "-90% 0px 0px 0px",
      // threshold: [1, 0],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          content.classList.add("narrow");
        } else {
          content.classList.remove("narrow");
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  const isPresent = document.getElementsByClassName("sliding-slider-content");
  if (isPresent.length > 0) {
    init();
  }
}

export { narrowSlidingSliderControls };
